import { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import {
  MdDescription,
  MdEmail,
  MdLocationOn,
  MdLock,
  MdPerson,
  MdPhone,
  MdVisibility,
  MdVisibilityOff,
} from "react-icons/md";
import { FiCamera, FiCheck } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useTheme } from "../../../contexts/ThemeContext";
import SellerMasterLayout from "../../../layouts/seller/SellerMasterLayout";
import AppContext from "../../../contexts/AppContext";
import "../../../assets/css/seller/screens/SellerProfile.css";

// ── MY PROFILE ──────────────────────────────────────────
const MyProfile = () => {
  const fileRef = useRef(null);
  const { baseUrl, baseUrlForFiles , setSeller , sellerAuthToken } = useContext(AppContext);

  const [sellerData, setSellerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    gender: "",
    description: "",
    city: "",
  });

  const viewProfile = () => {
    setLoading(true);
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const seller_id = seller?.id;

    const formdata = new FormData();
    formdata.append("seller_id", seller_id);

    axios
      .post(`${baseUrl}/seller/profile/viewProfile`, formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },)
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          const seller = response.data.seller;
          setForm({
            full_name: seller.full_name || "",
            email: seller.email || "",
            phone: seller.phone || "",
            gender: seller.gender || "",
            description: seller.description || "",
            city: seller.city || "",
          });
          if (seller.profile_image) {
            setImgPreview(`${baseUrlForFiles}/${seller.profile_image}`);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    viewProfile();
  }, []);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onFile = (e) => {
    const f = e.target.files[0];
    if (f) {
      setSelectedFile(f);
      setImgPreview(URL.createObjectURL(f));
    }
  };

const updateProfile = () => {
  setSaving(true);

  const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
  const seller_id = seller?.id;

  const formdata = new FormData();
  formdata.append("seller_id", seller_id);
  formdata.append("full_name", form.full_name);
  formdata.append("email", form.email);
  formdata.append("phone", form.phone);
  formdata.append("gender", form.gender);
  formdata.append("description", form.description);
  formdata.append("city", form.city);

  if (selectedFile) {
    formdata.append("profile_image", selectedFile);
  }

  axios
    .post(`${baseUrl}/seller/profile/updateProfile`, formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },)
    .then((response) => {
      if (response.data.success) {
        toast.success("Profile updated successfully!");

        const updatedSeller = response.data.seller;

        if (updatedSeller) {
          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify(updatedSeller),
          );
          setSeller(updatedSeller);
          viewProfile();
        }
      }

      setSaving(false);
    })
    .catch((error) => {
      console.log(error);
      toast.error("Profile update failed. Please try again.");
      setSaving(false);
    });
};

  const initials = (n) =>
    n
      ? n
          .split(" ")
          .map((w) => w[0])
          .join("")
          .toUpperCase()
          .slice(0, 2)
      : "S";

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "60px" }}>
        <div
          className="spinner-border"
          style={{ color: "#ff8559" }}
          role="status"
        />
        <p style={{ color: "#999", marginTop: 12 }}>Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="spp-layout">
      {/* ── LEFT: info card ── */}
      <div className="spp-left-card">
        <div
          className="spp-left-avatar-wrap"
          onClick={() => fileRef.current.click()}
        >
          {imgPreview ? (
            <img
              src={imgPreview}
              alt="Profile"
              className="spp-left-avatar-img"
            />
          ) : form.full_name ? (
            <span className="spp-left-avatar-text">
              {form.full_name.charAt(0).toUpperCase()}
            </span>
          ) : (
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff8559"
              strokeWidth="1.5"
            >
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
          )}
          <div className="spp-cam-dot">
            <FiCamera size={10} />
          </div>
        </div>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          onChange={onFile}
          style={{ display: "none" }}
        />
        <p className="spp-left-hint">JPG or PNG, max 5MB</p>
        <div className="spp-left-divider" />

        {[
          { icon: <MdPerson />, label: "Full Name", val: form.full_name },
          { icon: <MdEmail />, label: "Email", val: form.email },
          { icon: <MdPhone />, label: "Phone", val: form.phone },
          { icon: <MdPerson />, label: "Gender", val: form.gender },
          { icon: <MdLocationOn />, label: "City", val: form.city },
        ].map((r) => (
          <div className="spp-left-row" key={r.label}>
            <span className="spp-left-row-icon">{r.icon}</span>
            <div>
              <p className="spp-left-row-label">{r.label}</p>
              <p className="spp-left-row-val">{r.val || "—"}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ── RIGHT: edit form ── */}
      <div className="spp-right-card">
        <p className="spp-form-tag">User Information</p>
        <h5 className="spp-form-head">Profile</h5>

        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="spp-lbl">Full Name</Form.Label>
              <div className="spp-field">
                <MdPerson className="spp-ficon" />
                <Form.Control
                  type="text"
                  name="full_name"
                  value={form.full_name}
                  onChange={onChange}
                  placeholder="Enter full name"
                  className="spp-inp"
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="spp-lbl">Email Address</Form.Label>
              <div className="spp-field">
                <MdEmail className="spp-ficon" />
                <Form.Control
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="Enter email"
                  className="spp-inp"
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="spp-lbl">Phone Number</Form.Label>
              <div className="spp-field">
                <MdPhone className="spp-ficon" />
                <Form.Control
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={onChange}
                  placeholder="+92 300 1234567"
                  className="spp-inp"
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="spp-lbl">Gender</Form.Label>
              <div className="spp-field">
                <MdPerson className="spp-ficon" />
                <Form.Select
                  name="gender"
                  value={form.gender}
                  onChange={onChange}
                  className="spp-inp spp-sel"
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                  <option value="Prefer not to say">Prefer not to say</option>
                </Form.Select>
              </div>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="spp-lbl">City</Form.Label>
              <div className="spp-field">
                <MdLocationOn className="spp-ficon" />
                <Form.Control
                  type="text"
                  name="city"
                  value={form.city}
                  onChange={onChange}
                  placeholder="e.g. Karachi, Pakistan"
                  className="spp-inp"
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Label className="spp-lbl">Bio / Description</Form.Label>
              <div className="spp-field spp-ta-field">
                <MdDescription className="spp-ficon spp-ficon-top" />
                <Form.Control
                  as="textarea"
                  name="description"
                  value={form.description}
                  onChange={onChange}
                  rows={3}
                  placeholder="Tell buyers about yourself..."
                  className="spp-inp spp-ta"
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        <div className="spp-save-row">
          <Button
            type="button"
            onClick={updateProfile}
            disabled={saving}
            className="spp-save-btn"
          >
            {saving ? "Saving..." : "Save Now"}
          </Button>
        </div>
      </div>
    </div>
  );
};

// ── CHANGE PASSWORD ──────────────────────────────────────
const ChangePassword = () => {
  const { baseUrl ,sellerAuthToken} = useContext(AppContext);
  const [form, setForm] = useState({ cur: "", nw: "", conf: "" });
  const [show, setShow] = useState({ cur: false, nw: false, conf: false });
  const [errs, setErrs] = useState({});
  const [saving, setSaving] = useState(false);

  const toggle = (k) => setShow((p) => ({ ...p, [k]: !p[k] }));
  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrs({ ...errs, [e.target.name]: "" });
  };

  const strength = (p) => {
    if (!p) return { level: 0, label: "" };
    let s = 0;
    if (p.length >= 8) s++;
    if (/[A-Z]/.test(p)) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[^A-Za-z0-9]/.test(p)) s++;
    return { level: s, label: ["", "Weak", "Fair", "Good", "Strong"][s] };
  };
  const str = strength(form.nw);
  const sCols = ["", "#ef4444", "#f59e0b", "#3b82f6", "#22c55e"];

  const validate = () => {
    const e = {};
    if (!form.cur) e.cur = "Current password is required.";
    if (!form.nw) e.nw = "New password is required.";
    else if (form.nw.length < 8) e.nw = "Minimum 8 characters.";
    if (!form.conf) e.conf = "Please confirm your password.";
    else if (form.nw !== form.conf) e.conf = "Passwords do not match.";
    return e;
  };

  // const onSave = () => {
  //   const e = validate();
  //   if (Object.keys(e).length) {
  //     setErrs(e);
  //     return;
  //   }
  //   setSaving(true);
  //   setTimeout(() => {
  //     setSaving(false);
  //     toast.success("Password changed!", {
  //       position: "top-right",
  //       autoClose: 3000,
  //     });
  //     setForm({ cur: "", nw: "", conf: "" });
  //   }, 1000);
  // };

  const onSave = () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrs(e);
      return;
    }
    setSaving(true);

    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const seller_id = seller?.id;
    const formdata = new FormData();
    formdata.append("seller_id", seller_id);
    formdata.append("current_password", form.cur);
    formdata.append("new_password", form.nw);

    axios
      .post(`${baseUrl}/seller/changePassword`, formdata, {
        headers: {
          Authorization: `Bearer ${sellerAuthToken}`,
        },
      })
      .then((response) => {
        setSaving(false);
        if (response.data.success) {
          toast.success("Password changed!", {
            position: "top-right",
            autoClose: 3000,
          });
          setForm({ cur: "", nw: "", conf: "" });
        } else {
          setErrs({ cur: response.data.message || "Something went wrong." });
        }
      })
      .catch((error) => {
        console.log(error);
        setSaving(false);
        setErrs({ cur: "Password update failed. Please try again." });
      });
  };

  const fields = [
    { key: "cur", label: "Current Password", ph: "Enter current password" },
    { key: "nw", label: "New Password", ph: "Enter new password" },
    { key: "conf", label: "Confirm New Password", ph: "Confirm new password" },
  ];

  return (
    <Row className="justify-content-center">
      <Col lg={8} md={10} sm={12}>
        <div className="spp-right-card">
          <div className="spp-cp-hdr">
            <div className="spp-cp-icon">
              <MdLock size={20} />
            </div>
            <div>
              <h5 className="spp-form-head mb-1">Change Password</h5>
              <p className="spp-cp-sub">
                Keep your account secure with a strong password
              </p>
            </div>
          </div>

          <div className="spp-tips-box">
            <p className="spp-kyc-title">Password Tips</p>
            <ul className="spp-kyc-list">
              <li>At least 8 characters long</li>
              <li>Include uppercase &amp; lowercase letters</li>
              <li>Include numbers and special symbols</li>
              <li>Do not reuse old passwords</li>
            </ul>
          </div>

          {fields.map(({ key, label, ph }) => (
            <Form.Group className="spp-pw-grp" key={key}>
              <Form.Label className="spp-lbl">{label}</Form.Label>
              <div className="spp-pw-field">
                <MdLock className="spp-ficon" />
                <Form.Control
                  type={show[key] ? "text" : "password"}
                  name={key}
                  value={form[key]}
                  onChange={onChange}
                  placeholder={ph}
                  autoComplete="new-password" // yeh add karo
                  className={`spp-inp spp-pw-inp ${errs[key] ? "spp-inp-err" : ""}`}
                />
                <button
                  type="button"
                  className="spp-eye"
                  onClick={() => toggle(key)}
                >
                  {show[key] ? (
                    <MdVisibilityOff size={17} />
                  ) : (
                    <MdVisibility size={17} />
                  )}
                </button>
              </div>
              {errs[key] && <p className="spp-err">{errs[key]}</p>}
              {key === "nw" && form.nw && (
                <div className="spp-str-row">
                  <div className="spp-str-bars">
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        className="spp-str-bar"
                        style={{
                          background:
                            str.level >= i ? sCols[str.level] : "#e2e8f0",
                        }}
                      />
                    ))}
                  </div>
                  <span
                    className="spp-str-lbl"
                    style={{ color: sCols[str.level] }}
                  >
                    {str.label}
                  </span>
                </div>
              )}
              {key === "conf" && form.conf && form.nw === form.conf && (
                <p className="spp-match">
                  <FiCheck size={12} /> Passwords match
                </p>
              )}
            </Form.Group>
          ))}

          <div className="spp-cp-btns">
            <button
              type="button"
              className="spp-reset-btn"
              onClick={() => setForm({ cur: "", nw: "", conf: "" })}
            >
              Reset
            </button>
            <Button
              type="button"
              className="spp-update-btn"
              onClick={onSave}
              disabled={saving}
            >
              {saving ? "Updating..." : "Update Password"}
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};

// ── MAIN PAGE ─────────────────────────────────────────────
const SellerProfilePage = () => {
  const { isDark } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const getTab = () =>
    location.pathname.includes("change-password") ? "password" : "profile";
  const [tab, setTab] = useState(getTab());

  const handleTab = (t) => {
    setTab(t);
    if (t === "profile") navigate("/seller/profile");
    if (t === "password") navigate("/seller/change-password");
  };

  const tabs = [
    { key: "profile", label: "My Profile", icon: <MdPerson size={16} /> },
    { key: "password", label: "Change Password", icon: <MdLock size={16} /> },
  ];

  return (
    <SellerMasterLayout>
      <ToastContainer />
      <div className={`spp-page ${isDark ? "dark-mode" : ""}`}>
        <Container fluid className="spp-container">
          <div className="spp-tabs">
            {tabs.map((t) => (
              <button
                key={t.key}
                className={`spp-tab ${tab === t.key ? "active" : ""}`}
                onClick={() => handleTab(t.key)}
              >
                <span className="spp-tab-icon">{t.icon}</span>
                <span className="spp-tab-lbl">{t.label}</span>
              </button>
            ))}
          </div>
          <div className="spp-content">
            {tab === "profile" && <MyProfile />}
            {tab === "password" && <ChangePassword />}
          </div>
        </Container>
      </div>
    </SellerMasterLayout>
  );
};

export default SellerProfilePage;
